module.exports = __webpack_public_path__ + "static/media/settingTeamActive.1e80eadf.png";